































































































import vue from "vue";
export default {
  computed: {
    wordsWidth() {
      if (window.screen.width >= 850) {
        return "850px";
      }
      if (window.screen.width <= 850 && window.screen.width >= 710) {
        return "700px";
      }
      if (window.screen.width <= 710 && window.screen.width >= 610) {
        return "600px";
      }

      if (window.screen.width <= 610 && window.screen.width >= 530) {
        return "520px";
      }
      if (window.screen.width <= 530 && window.screen.width >= 410) {
        return "400px";
      }
      if (window.screen.width <= 410) {
        return "300px";
      }
      return "300px";
    }
  }
};
